'use client';

import { scrollAnchorSection } from '@stereoagency/sanity-schema';

type Props = typeof scrollAnchorSection.schema.scrollAnchorSection;

export default function ScrollAnchorSection({ id }: Props) {
  return (
    <div role="presentation" id={id} style={{ margin: '0px', height: '0px' }} />
  );
}
